export class ChangeCompanyInput {
  companyId: string;
}
